/**
 * This component renders the schedule for a division page
 */
import React, { useState } from "react";

import Schedule from "../core/Schedule";

const DivisionSchedule = ({ divisionData }) => {

  // get teams from division info
  const parseTeams = (data) => {
    const teamsArray = [];
    data.teams.map((team) => {
      if (team.rank > 0) teamsArray.push(team);
    });
    return teamsArray;
  }

  console.log(divisionData)

  return (
    // Container for all pages
    <Schedule 
      mode="division" 
      teams={parseTeams(divisionData)}
      clubs={[]}
      id={divisionData.id}
      seasons={[{value: divisionData.season_offset}]}
      is_nationals={divisionData.is_nationals}
    />

  );
}
export default DivisionSchedule;